import PlanEntryFinishedListRequest, {
  PlanEntryFinishedListingRequestOrder,
} from "../../../api/raily/plan-entry/finished-list/plan-entry-finished-list.request";
import paginationService from "../../../utils/pagination/pagination.service";
import PlanEntryFinishedListParams, {
  PlanEntryFinishedListParamsOrder,
} from "./plan-entry-finished-list-params";

const createOrder = (
  status: PlanEntryFinishedListParamsOrder | undefined,
): PlanEntryFinishedListingRequestOrder | undefined => {
  switch (status) {
    case PlanEntryFinishedListParamsOrder.DRIVER_ASC:
      return PlanEntryFinishedListingRequestOrder.DRIVER_ASC;
    case PlanEntryFinishedListParamsOrder.DRIVER_DESC:
      return PlanEntryFinishedListingRequestOrder.DRIVER_ASC;
    case PlanEntryFinishedListParamsOrder.HUMAN_ID_ASC:
      return PlanEntryFinishedListingRequestOrder.HUMAN_ID_ASC;
    case PlanEntryFinishedListParamsOrder.HUMAN_ID_DESC:
      return PlanEntryFinishedListingRequestOrder.HUMAN_ID_DESC;
    case PlanEntryFinishedListParamsOrder.TAXI_CORPORATION_ASC:
      return PlanEntryFinishedListingRequestOrder.TAXI_CORPORATION_ASC;
    case PlanEntryFinishedListParamsOrder.TAXI_CORPORATION_DESC:
      return PlanEntryFinishedListingRequestOrder.TAXI_CORPORATION_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: PlanEntryFinishedListParams,
): PlanEntryFinishedListRequest => {
  return {
    order: createOrder(params.order),
    taxiCorporationId: params.taxiCorporationUuid,
    driverId: params.driverUuid,
    driverName: params.driverName ? [params.driverName] : [],
    taxiName: params.taxiName ? [params.taxiName] : [],
    planEntryNodes: params.planEntryNodes ? [params.planEntryNodes] : [],
    startingNodeLabel: params.startingNodeLabel
      ? [params.startingNodeLabel]
      : [],
    endingNodeLabel: params.endingNodeLabel ? [params.endingNodeLabel] : [],
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    endTimeSince: params.endTimeSince,
    endTimeTo: params.endTimeTo,
    humanId: params.humanId ? [params.humanId] : [],
    involvedCargoLabels: params.involvedCargoLabels
      ? [params.involvedCargoLabels]
      : [],
    isBilled: params.isBilled,
    cargoOrderId: params.cargoOrderUuid,
    cargoOrderHumanId: params.cargoOrderHumanId,
    creationStart: params.creationStart,
    creationEnd: params.creationEnd,
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
  };
};

const planEntryFinishedListParamsFactory = {
  create,
};

export default planEntryFinishedListParamsFactory;
